<template>
  <body class="hold-transition sidebar-mini sidebar-collapse">
    <!-- <div class="wrapper"> -->
    <div class="wrapper">
      <!-- Componente correspondiente al header de la app -->
      <Header />

      <!-- Componente correspondiente al menu de la app -->
      <SideMenu />

      <!-- Cuerpo -->
      <div class="content-wrapper">
        <!-- Componente correspondiente al Breadcrumb de la app -->
        <Breadcrumb class="px-2" />

        <!-- Tarjetas para la sección administración -->
        <CardAdministracion
          v-if="seccion_actual == 'dashboard'"
          class="px-2"
          style="min-height: 0px !important"
        />

        <CardAdministracion
          v-else-if="seccion_actual == 'administracion'"
          class="px-2"
          style="min-height: 0px !important"
        />

        <!-- Tarjetas para la sección booking -->
        <div v-else-if="seccion_actual == 'booking'">
          <steps-bookings-perfil-usuario
            :rol="usuarioActual.rol"
            class="px-2"
          />
        </div>
        
        <div class="p-2" v-else-if="seccion_actual == 'superadministrador'">
          Agregar widget con información general
        </div>

        <!-- Tarjetas para la sección booking -->
        <div v-else-if="seccion_actual == 'shippinginstructions'">
          <shipping-instructions-menu :rol="usuarioActual.rol" class="px-2" />
        </div>

        <div v-else-if="seccion_actual == 'liquidaciones_extra_costos'">
          <liquidaciones-extra-costos-menu />
        </div>

        <!-- Router View -->
        <div style="padding: 10px">
          <router-view class="w-100" />
        </div>
      </div>

      <!-- Footer -->
      <Footer />
    </div>
  </body>
</template>

<script>
// Vuex
import { mapState } from "vuex";

// Componente Side Menu
import SideMenu from "../components/common/SideMenu";

// Componente Header
import Header from "../components/common/HeaderComponent";

// Componente Breadcrumb
import Breadcrumb from "../components/common/Breadcrumb";

// Componente CardAdministracion
import CardAdministracion from "../components/cards/CardAdministracion";

// Componente StepsBookingsPerfilUsuario
import StepsBookingsPerfilUsuario from "../components/common/StepsBookingsPerfilUsuario";

// Componente ShippingInstructionsMenu
import ShippingInstructionsMenu from "../components/common/ShippingInstructionsMenu";

// Componente Liquidaciones Extra Costos
import LiquidacionesExtraCostosMenu from "../components/common/LiquidacionExtraCostosMenu";

// Componente Footer
import Footer from "../components/common/FooterComponent";

export default {
  data() {
    return {
      mostrarCardAdministracion: false,
    };
  },
  components: {
    Header,
    SideMenu,
    Footer,
    Breadcrumb,
    CardAdministracion,
    StepsBookingsPerfilUsuario,
    ShippingInstructionsMenu,
    LiquidacionesExtraCostosMenu
    // CardBooking,
  },
  computed: {
    ...mapState([
      "url_actual",
      "seccion_actual",
      "isLoadPage",
      "usuarioActual",
    ]),

    ...mapState("subseccionesLineas", ["isLateArrivals"]),
  },
};
</script>
